import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SessionDetailCardModalComponent, SessionDetailCardModalType } from 'src/app/pages/admin/org-admin/components/modals/session-detail-card-modal/session-detail-card-modal.component';
import { ModalService } from './modal.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IUrlModalState, UrlModalType } from '../modals/modal';
import { StoreService } from './store/store.service';
import { filter, take } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UrlModalService {

  openUrlModals: {state: IUrlModalState, ref: NgbModalRef | undefined }[] = [
    // {
    //   type: UrlModalType.SESSION_DETAIL_CARD,
    //   data: {
    //     id: 'a1c69ab8-f458-4266-a967-d5d3d657785e', // will be set later
    //     type: SessionDetailCardModalType.LECTURER // or EDIT
    //   }
    // }
  ];
  private isReplaying = false;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: ModalService,
    private store: StoreService,
    private location: Location,
  ) {
      // wait until the first NavigationEnd fires
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {
      const raw = this.route.snapshot.queryParamMap.get('modals');
      if (raw) {
        this.isReplaying = true;
        const states = JSON.parse(decodeURIComponent(raw)) as IUrlModalState[];
        this.openUrlModals = states.map(s => ({ state: s, ref: undefined }));
        this.replayUrlModals();
        this.isReplaying = false;
      }
    });

    this.store.actions.modals_openedUlrModal$.pipe(
      filter(() => !this.isReplaying)
    ).subscribe(({ state, ref }) => {
      // add to the list of open modals
      this.openUrlModals.push({ state, ref });
      // update the URL
      this.updateUrl();

      ref!.result.finally(() => {
        console.log('qqqqqqqqqqqqqq')
      })

    })
  }

  
  private replayUrlModals() {
    // close all first
    // this.dialog.closeAll();
    for (const m of this.openUrlModals) {
      m.ref?.close();

    }
    // then re-open in order
    for (const m of this.openUrlModals) {
      let ref: NgbModalRef | undefined;

      switch (m.state.type) {
        case UrlModalType.SESSION_DETAIL_CARD:
          const id = m.state.data.id as string;
          const t  = m.state.data.type as SessionDetailCardModalType;
          if (!id || !t) continue;

          ref = this.modalService.openSessionDetailCardModal(SessionDetailCardModalComponent, id, t, 'system')!;
          m.ref = ref;
          break;
      }
      if (ref) {
        
        ref!.result.finally(() => {
          this.handleModalCLose(ref!);
        })
      }
    }
  }

  /** Update the browser URL (no reload) */
  private updateUrl() {
    if (this.isReplaying) {
      return;
    }
    const payload =  this.openUrlModals.length ? JSON.stringify(this.openUrlModals.map(x => x.state)) : null;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { modals: payload },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  private handleModalCLose(ref: NgbModalRef) {
    this.openUrlModals = this.openUrlModals.filter(m => m.ref?.componentInstance.modalId !== ref!.componentInstance.modalId);
    this.updateUrl();
  }
}
